import { FormItemProps, message } from "antd";
import {
  AppProfileModel,
  AssetsModel,
  ParticipantsModel,
} from "api/repositories/appProfileRegister/models/AppProfileModel";
import axios from "axios";
import { isEmpty, isUndefined } from "lodash";
import { AppProfileRegisterConstants } from "pages/appProfileRegister/view/constants";
import { strings } from "utils/localizedStrings";

export const createFormRules = (
  stricted: boolean,
  dataType: string,
  message: string
) => {
  return [
    {
      required: stricted,
      type: dataType,
      message: message,
    },
  ] as FormItemProps["rules"];
};

export const getFormInitialVals = <O extends Object>(
  data: O,
  value: keyof O
) => {
  if (!isEmpty(data)) {
    return data[value];
  } else {
    return undefined;
  }
};

export const getMessage = (
  info: string,
  time: number,
  type: "success" | "error" | "warning"
) => {
  switch (type) {
    case "success":
      return message.success({
        content: info,
        duration: time,
      });
    case "error":
      return message.error({
        content: info,
        duration: time,
      });
    case "warning":
      return message.warning({
        content: info,
        duration: time,
      });
  }
};

export const renderStatus = (value: unknown) => {
  switch (value) {
    case "active":
      return (
        <span className="font-semibold text-green-700">
          {strings.GlobalLabels.Active}
        </span>
      );
    case "inactive":
      return (
        <span className="font-semibold text-red-700">
          {strings.GlobalLabels.Inactive}
        </span>
      );
    case 0:
      return (
        <span className="font-semibold text-green-700">
          {strings.GlobalLabels.Active}
        </span>
      );
    case 1:
      return (
        <span className="font-semibold text-red-700">
          {strings.GlobalLabels.Inactive}
        </span>
      );
    case -1:
      return (
        <span className="font-semibold text-red-700">
          {strings.GlobalLabels.Inactive}
        </span>
      );
  }
};

export const convertToISO = (dateStr: {
  $y: number;
  $M: number;
  $D: number;
}) => {
  const year = dateStr.$y;
  const month = dateStr.$M + 1;
  const day = dateStr.$D;
  const isoDate = `${year.toString().padStart(4, "0")}-${month
    .toString()
    .padStart(2, "0")}-${day.toString().padStart(2, "0")}T00:00:00.000Z`;
  return isoDate;
};

export const getUserType = (value: string) => {
  switch (value) {
    case "user":
      return <span style={{ color: "#473b3b", fontWeight: 700 }}>User</span>;
    case "admin":
      return <span style={{ color: "#180d7a", fontWeight: 700 }}>Admin</span>;
    case "partner":
      return <span style={{ color: "#650d7a", fontWeight: 700 }}>Partner</span>;
  }
};

export const getUserStatus = (value: number) => {
  switch (value) {
    case 0:
      return (
        <span style={{ color: "#32a852", fontWeight: 700 }}>
          {strings.GlobalLabels.Active}
        </span>
      );
    case 1:
      return (
        <span style={{ color: "#b37f27", fontWeight: 700 }}>
          {strings.GlobalLabels.Inactive}
        </span>
      );
    case 2:
      return (
        <span style={{ color: "#ab1111", fontWeight: 700 }}>
          {strings.GlobalLabels.Deleted}
        </span>
      );
  }
};

export const getStatus = (value: number) => {
  switch (value) {
    case 0:
      return (
        <span style={{ color: "#d9a61c", fontWeight: 700 }}>Khởi tạo</span>
      );
    case 1:
      return (
        <span style={{ color: "#2029a8", fontWeight: 700 }}>Đang xử lý</span>
      );
    case 2:
      return (
        <span style={{ color: "green", fontWeight: 700 }}>Hoàn thành</span>
      );
    case 3:
      return <span style={{ color: "red", fontWeight: 700 }}>Lỗi</span>;
    case 4:
      return <span style={{ color: "#730d34", fontWeight: 700 }}>Đã xóa</span>;
    case 5:
      return (
        <span style={{ color: "#c79712", fontWeight: 700 }}>Chờ xác nhận</span>
      );
    default:
      return "";
  }
};

export const statusForContent = (value: number) => {
  switch (value) {
    case 0:
      return <span className="text-green-600 font-bold">Hoạt động</span>;
    case 1:
      return <span className="text-red-700 font-bold">Không hoạt động</span>;
    default:
      return "";
  }
};

export const statusForSimApplication = (value: number) => {
  switch (value) {
    case 10:
      return "Chờ thanh toán";
    case 11:
      return "Chờ giao hàng";
    case 12:
      return "Chờ nhận hàng";
    case 13:
      return "Giao hàng thành công";
    case 14:
      return "Đã hủy";
    case 15:
      return "Đã hòa mạng";
    case 16:
      return "Hòa mạng thất bại";
    default:
      return "";
  }
};

export const statusForDetails = (value: number) => {
  switch (value) {
    case 0:
      return "Khởi tạo";
    case 1:
      return "Đang xử lý";
    case 2:
      return "Hoàn thành";
    case 3:
      return "Lỗi";
    case 4:
      return "Đã xóa";
    case 5:
      return "Chờ xác nhận";
    default:
      return "";
  }
};

export const formatCurrency = (value: string | number, noStyle = false) => {
  return (
    <span
      style={
        !noStyle
          ? {
              fontWeight: 550,
              color:
                (value as number) > 0 || parseInt(value as string) > 0
                  ? "green"
                  : "red",
            }
          : null
      }
    >
      {`${new Intl.NumberFormat().format(
        typeof value === "string" ? parseInt(value) : value
      )} VND`}
    </span>
  );
};

export const DataFormater = (number: number) => {
  if (number >= 1000000000) {
    return (number / 1000000000).toString() + "B";
  } else if (number >= 1000000) {
    return (number / 1000000).toString() + "M";
  } else if (number >= 1000) {
    return (number / 1000).toString() + "K";
  } else {
    return number.toString();
  }
};

export const autoCorrectJSON = (jsonString: string): string => {
  let correctedJSON = jsonString
    .replace(/(?<=\{|\,)\s*([\w]+)\s*:/g, '"$1":')
    .replace(/(?<=:)\s*'([^']*)'\s*(?=,|\}|$)/g, ' "$1"');
  correctedJSON = correctedJSON.replace(/,\s*([\]}])/g, "$1");
  return correctedJSON;
};

export const paramsChecking = <T extends unknown>(
  value: T | undefined,
  type: "select" | "input"
) => {
  switch (type) {
    case "select":
      return value === strings.GlobalLabels.All ? undefined : value;
    case "input":
      return isEmpty(value) || isUndefined(value) ? undefined : value;
  }
};

export const avoidDuplicate = <T extends string | number | boolean | Object>(
  baseInfo: T,
  newInfo: typeof baseInfo
) => {
  if (newInfo === baseInfo) {
    return undefined;
  } else {
    return newInfo;
  }
};

export const areEqual = (arr1: Array<unknown>, arr2: Array<unknown>) => {
  let N = arr1.length;
  let M = arr2.length;

  if (N !== M) return false;

  arr1.sort();
  arr2.sort();

  for (let i = 0; i < N; i++) if (arr1[i] !== arr2[i]) return false;
  return true;
};

export const toMbAndHour = <T extends number>(
  unit: string,
  baseValue: T,
  newValue: T
) => {
  if (unit === "mb" || unit === "gb") {
    let value = Math.round(((newValue as number) / 1000) * 200) / 200;
    return avoidDuplicate(baseValue, unit === "mb" ? value : newValue);
  } else {
    return unit === "hour" && newValue >= 1
      ? avoidDuplicate(baseValue, Math.round(newValue / 24))
      : newValue < 1 && unit === "hour"
      ? avoidDuplicate(baseValue, newValue)
      : newValue < 1 && unit === "day"
      ? avoidDuplicate(baseValue, Math.round(newValue * 24))
      : avoidDuplicate(baseValue, newValue);
  }
};

export const downloadFile = async (fileUrl: string, title: string) => {
  try {
    const response = await axios({
      method: "GET",
      url: fileUrl,
      responseType: "arraybuffer",
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      }
    });
    const contentType =
      response.headers["content-type"] || "application/octet-stream";
    const blob = new Blob([response.data], { type: contentType });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = title;
    link.click();
  } catch (error) {
    console.error("Error downloading the file:", error);
  }
};

export const downloadFileFromBlob = (blob: Blob, title: string) => {
  const link = document.createElement("a");
  link.href = URL.createObjectURL(blob);
  link.download = title;
  link.click();
}

export const uppercaseFirstLetter = (str: string) => {
  return str?.charAt(0)?.toUpperCase() + str?.slice(1);
};

export const renderItem = (
  label: string,
  value: React.ReactNode,
  color = "black"
) => {
  return (
    <div className="flex justify-between w-full my-2">
      <span className="font-bold min-w-[100px]">{label}:</span>
      <span
        style={{
          color: color,
          fontWeight: color !== "black" ? "bold" : "",
          textAlign: "right",
        }}
        className="overflow-visible text-ellipsis"
      >
        {value && value !== "-" && value !== "Invalid Date"
          ? value
          : strings.GlobalLabels.NoInfo}
      </span>
    </div>
  );
};

export const combineImages = (contract: AppProfileModel) => {
  const images: AssetsModel[] = [];

  // Gom tất cả files vào một mảng tạm để xử lý group
  const allFiles: (AssetsModel & { phoneNumber?: string })[] = [];

  // Lấy từ businessCerts
  if (contract?.organization?.businessCerts?.length > 0) {
    contract.organization.businessCerts.forEach((item) => {
      allFiles.push({ ...item });
    });
  }

  // Lấy từ participants
  if (contract?.participants?.length > 0) {
    contract.participants.forEach((user: ParticipantsModel) => {
      user?.files?.forEach((file: AssetsModel) => {
        allFiles.push({ ...file, phoneNumber: user.phoneNumber });
      });
    });
  }

  // Lấy từ file
  if (!isEmpty(contract?.file)) {
    allFiles.push({
      ...contract.file,
      phoneNumber: contract.participants[0]?.phoneNumber,
    });
  }

  // Group theo classify
  const grouped = allFiles.reduce((acc, file) => {
    const key = file.classify;
    if (!acc[key]) acc[key] = [];
    acc[key].push(file);
    return acc;
  }, {} as Record<number, (AssetsModel & { phoneNumber?: string })[]>);

  // Tạo label theo thứ tự trong mỗi nhóm
  Object.entries(grouped).forEach(([classify, files]) => {
    files.forEach((file, index) => {
      const titleBase = AppProfileRegisterConstants.getAssetsLabel(
        Number(classify)
      );
      const count = files.length;
      const label = `${titleBase} ${
        file?.phoneNumber ? `- ${file?.phoneNumber}` : ""
      } ${count > 1 ? `(${index + 1}/${count})` : ""}`;

      images.push({
        ...file,
        title: label,
      });
    });
  });

  return images;
};

export const parseNoteString = (
  note: string
): Record<string, string | string[]> => {
  if (!note) return;
  const parts = note.split("|");
  const result: Record<string, string | string[]> = {};
  const products: string[] = [];

  for (const part of parts) {
    if (part.includes("=")) {
      const [key, value] = part.split("=");
      result[key] = value;
    } else if (part.trim() !== "") {
      products.push(part);
    }
  }

  if (products.length > 0) {
    result["product"] = products.length === 1 ? products[0] : products;
  }

  return result;
};
